import { useState } from 'react'
import { useRouter } from 'next/router'
import { OrderFormat } from '@ancon/wildcat-types'

import OutletDetailsModal from '../../../outlet/components/outletDetailsModal/OutletDetailsModal'
import NewOrderTimeConfigureModal from '../newOrderTimeConfigureModal/NewOrderTimeConfigureModal'
import { preOrderCheckoutOutletIdSelector } from '../../../preOrder/store/preOrderSelectors'
import useAppStore from '../../../../store/hooks/useAppStore'
import {
  outletsSelectedOutletListIdSelector,
  outletsSelectedOutletListItemSelector,
} from '../../store/outletsSelectors'
import useAppDispatch from '../../../../store/hooks/useAppDispatch'
import LeavePreOrderWarningModal from '../../../preOrder/components/LeavePreOrderWarningModal'
import { setPreOrderExistWarningModalVisible } from '../../../preOrder/store/preOrderSlice'
import { AppRoutes, OrderFormatSlugMap } from '../../../app/constants'

import NewOrderCardModal from './NewOrderCardModal'
import NewOrderCard from './NewOrderCard'

export default function NewOrder() {
  const store = useAppStore()
  const dispatch = useAppDispatch()
  const router = useRouter()
  const [selectedOrderFormat, setSelectedOrderFormat] = useState<OrderFormat>()
  const [isVisibleTimeConfigurationModal, setIsVisibleTimeConfigurationModal] =
    useState(false)

  function clearSelectedOrderFormat() {
    setSelectedOrderFormat(undefined)
    setIsVisibleTimeConfigurationModal(false)
  }

  function startNewOrder(orderFormat: OrderFormat) {
    if (orderFormat === OrderFormat.TableOrder) {
      const outletListItem = outletsSelectedOutletListItemSelector(
        store.getState(),
      )

      if (outletListItem?.urlSlug) {
        router.push({
          pathname: `${AppRoutes.Outlet}/[outletSlug]`,
          query: {
            outletSlug: outletListItem.urlSlug,
            orderFormat: OrderFormatSlugMap[orderFormat],
            serviceTime: '',
          },
        })
      }
    } else {
      setIsVisibleTimeConfigurationModal(true)
    }
  }

  function handleOnClickOrderFormat(orderFormat: OrderFormat) {
    const preOrderOutletId = preOrderCheckoutOutletIdSelector(store.getState())
    const selectedOutletId = outletsSelectedOutletListIdSelector(
      store.getState(),
    )

    setSelectedOrderFormat(orderFormat)

    // Check wether pre-order exists
    if (preOrderOutletId === selectedOutletId) {
      dispatch(setPreOrderExistWarningModalVisible(true))
    } else {
      startNewOrder(orderFormat)
    }
  }

  function handleOnStartNewOrder() {
    if (selectedOrderFormat != null) {
      startNewOrder(selectedOrderFormat)
    }
  }

  function handleOnCloseLeavePreOrderWarningModal() {
    setSelectedOrderFormat(undefined)
  }

  return (
    <>
      <NewOrderCard onClickOrderFormat={handleOnClickOrderFormat} />
      <NewOrderCardModal onClickOrderFormat={handleOnClickOrderFormat} />
      <OutletDetailsModal isInOutletsPage />
      <NewOrderTimeConfigureModal
        isOpen={isVisibleTimeConfigurationModal}
        selectedOrderFormat={selectedOrderFormat}
        onClose={clearSelectedOrderFormat}
      />
      <LeavePreOrderWarningModal
        onStartNewOrder={handleOnStartNewOrder}
        onClose={handleOnCloseLeavePreOrderWarningModal}
      />
    </>
  )
}
